import React from 'react';
import { ready, appVersionComapare } from '../../lib/kbApp/kbJsBridgePromise';
import './index.scss';

class LoginComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTargetVersion: false,
    };
  }

  componentDidMount() {
    ready().then(() => appVersionComapare('11.4.5'))
      .then((res) => {
        this.setState({ isTargetVersion: res });
      });
  }

  onLogin = () => {
    this.props.onClickAction && this.props.onClickAction();
  };

  render() {
    return (
      <div className={`login ${this.props.from === 'mall' ? 'mall' : ''}`} onClick={() => this.onLogin()}>
        {this.state.isTargetVersion && <div className="phone"></div>}
        <div className="qq"></div>
        <div className="weixin"></div>
        <div className="desc">立即登录领金币</div>
      </div>
    );
  }
}

export default LoginComp;
